import './App.css';
import {useEffect} from 'react'
import Navbar from './components/Navbar';
import Skills from './components/Skills'
import Certs from './components/Certs';
import Footer from './components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Projects1 from './components/Projects';
import ProfileCard from './components/ProfileCard/ProfileCard';
import Portfolio from './components/Portfolio/Portfolio';
import Timeline from './components/Timeline';


function App() {
    useEffect(() => {
      document.title = 'Anjali Kumari Dubey';
      AOS.init();
    }, []);
  return (
    <div className='relative'>
     {/** <Background/> */}
      <div className="px-6 lg:px-20 xl:px-36 bg-[rgb(26, 25, 25)]">
      <Navbar />
      <Portfolio />
      <div className='line skline'></div>
      <Skills />
      <Projects1/>
      <Certs />
      <Timeline/>
      <ProfileCard/>
      <Footer />
    </div>
    </div>
  );
}

export default App;
